/**
 * Monaco injects theme CSS via <style class="monaco-colors"> without a CSP nonce.
 * Stamp Angular's CSP_NONCE on style creation, and re-attach any already-blocked sheets.
 */
let styleNonce: string | null = null;
let createElementPatched = false;

export function enableMonacoCspStyleNonce(nonce: string | null | undefined): void {
  if (typeof document === 'undefined' || !nonce) {
    return;
  }

  styleNonce = nonce;

  if (!createElementPatched) {
    createElementPatched = true;
    const originalCreateElement = Document.prototype.createElement;
    Document.prototype.createElement = function <K extends keyof HTMLElementTagNameMap>(
      tagName: K,
      options?: ElementCreationOptions
    ): HTMLElementTagNameMap[K] {
      const element = originalCreateElement.call(this, tagName, options) as HTMLElementTagNameMap[K];
      if (String(tagName).toLowerCase() === 'style' && styleNonce) {
        (element as HTMLStyleElement).nonce = styleNonce;
      }
      return element;
    } as typeof Document.prototype.createElement;
  }

  // Editor may have already inserted monaco-colors before this ran — re-attach if CSP blocked it.
  document.querySelectorAll<HTMLStyleElement>('style.monaco-colors').forEach(repairMonacoStyleElement);
}

function repairMonacoStyleElement(el: HTMLStyleElement): void {
  if (!styleNonce || !el.parentNode || el.sheet) {
    return;
  }

  el.nonce = styleNonce;
  const parent = el.parentNode;
  const nextSibling = el.nextSibling;
  parent.removeChild(el);
  parent.insertBefore(el, nextSibling);
}
